// extracted by mini-css-extract-plugin
export default {"mainContainer":"MenuLink_mainContainer__I39GF","boxContainer":"MenuLink_boxContainer__Ed0bH","linkBox":"MenuLink_linkBox__zYOhL"};